import assign from 'lodash.assign';
export class Evidence {
    constructor(init) {
        assign(this, init);
    }
    id;
    evidenceTypeCode;
    name;
    description;
    candidateStatement;
    confidentialityLevelCode;
    evidenceIssuingParty;
    documentReference;
    language;
}
